export default __webpack_public_path__ + "static/media/pricing-opensource.e2ef9c0f.jpeg";